import { render, staticRenderFns } from "./PaymentNewView.vue?vue&type=template&id=c5b376d8&scoped=true"
import script from "./PaymentNewView.vue?vue&type=script&lang=ts"
export * from "./PaymentNewView.vue?vue&type=script&lang=ts"
import style0 from "./PaymentNewView.vue?vue&type=style&index=0&id=c5b376d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b376d8",
  null
  
)

export default component.exports